import { BottomSheetModalProvider } from '@gorhom/bottom-sheet'
import { Suspense, type FC, type ReactNode } from 'react'
import { GestureHandlerRootView } from 'react-native-gesture-handler'
import { KeyboardProvider } from 'react-native-keyboard-controller'

import { BrandOffsetGradientView, SplashScreen } from '@/components'

import { AppReviewProvider } from './AppReviewProvider'
import { AppStateProvider } from './AppStateProvider'
import { AuthProvider } from './AuthProvider'
import { GluestackProvider } from './GluestackProvider'
import { MediaProvider } from './MediaProvider'
import { NavigationThemeProvider } from './NavigationThemeProvider'
import { NotificationsProvider } from './NotificationsProvider'
import { RelayProvider } from './RelayProvider'
import { RevenueCatProvider } from './RevenueCatProvider'

export interface ProvidersProps {
  children: ReactNode
}

export const Providers: FC<ProvidersProps> = ({ children }) => (
  <GestureHandlerRootView>
    <KeyboardProvider>
      <NavigationThemeProvider>
        <GluestackProvider>
          {/* without a fallback here, a suspension below unwinds to a boundary above the app whose fallback is
              blank, which hides this whole tree and flashes the bare black window */}
          <Suspense
            fallback={
              <BrandOffsetGradientView>
                <SplashScreen message='Loading' />
              </BrandOffsetGradientView>
            }
          >
            <AppStateProvider>
              <AuthProvider>
                <RelayProvider>
                  <BottomSheetModalProvider>
                    <AppReviewProvider>
                      <MediaProvider>
                        <NotificationsProvider>
                          <RevenueCatProvider>{children}</RevenueCatProvider>
                        </NotificationsProvider>
                      </MediaProvider>
                    </AppReviewProvider>
                  </BottomSheetModalProvider>
                </RelayProvider>
              </AuthProvider>
            </AppStateProvider>
          </Suspense>
        </GluestackProvider>
      </NavigationThemeProvider>
    </KeyboardProvider>
  </GestureHandlerRootView>
)
